import React, { useState, useEffect } from 'react'
import {
  Grid,
  Box,
  Modal,
  FormControl,
  TextField,
  Button,
  MenuItem,
  Select,
} from '@material-ui/core'
import { insertAsset } from '../../../../../services/Elegibilidad/create'
import swal from 'sweetalert'
import {
  getCurrency,
  getCurrencyByCountry,
} from '../../../../../services/Elegibilidad/get'
import NumberFormat from 'react-number-format'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ReactTooltip from 'react-tooltip'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

export const Modal36 = ({ open, setOpen, getDataTable }) => {
  const { idElegibilityForm, EligibilityForm, editFormElegibility } =
    useFormElegibilidad()
  const [currencyType, setCurrencyType] = useState([])
  const [loading, setLoading] = useState(false)
  const [errorActivo, setErrorActivo] = useState(false)
  const [errorDanio, setErrorDanio] = useState(false)
  const [errorEvento, setErrorEvento] = useState(false)

  const GeneralDataSchema = Yup.object().shape({
    PhysicalAsset: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(50, 'Máximo 50 caracteres'),
    AssetDamage: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(40, 'Máximo 40 caracteres'),
    AssetsNumber: Yup.number().required('Este campo es obligatorio'),
    AmountLocalCurrency: Yup.number().required('Este campo es obligatorio'),
    ClimaticEvent: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      IdAssetLossClimate: 0,
      IdElegibilityAnswer: idElegibilityForm,
      PhysicalAsset: '',
      AssetsNumber: '',
      AssetDamage: '',
      AmountLocalCurrency: '',
      AmountDollars: '',
      ClimaticEvent: '',
      IdCurrencySelected:
        EligibilityForm.IdCurrencyUser || editFormElegibility.IdCurrencyUser,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      handleGuardar(values)
    },
  })

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
    setErrorActivo(false)
    setErrorDanio(false)
    setErrorEvento(false)
  }

  // Función para obtener la moneda por pais
  const getListCurrencyByCountry = async () => {
    try {
      const responseCurrencyByCountry = await getCurrencyByCountry(
        EligibilityForm.IdCountryCredit || editFormElegibility.IdCountryCredit,
      )
      setCurrencyType(responseCurrencyByCountry.Data)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (currencyType.length === 0) getListCurrencyByCountry()
  }, [EligibilityForm.IdCountryCredit, editFormElegibility.IdCountryCredit])

  // Funcion para el cambio de la moneda
  const handleCurrency = async () => {
    let currency
    switch (
      EligibilityForm.IdCurrencyUser ||
      editFormElegibility.IdCurrencyUser
    ) {
      case 1:
        currency = 'HNL'
        break
      case 2:
        currency = 'NIC'
        break
      case 3:
        currency = 'DOM'
        break
      case 4:
        currency = 'CRC'
        break
      case 5:
        currency = 'GTQ'
        break
      case 6:
        currency = 'DOP'
        break
    }

    const dataCurrency = {
      SourceCurrencyCode: currency,
      TargetCurrencyCode: 'USD',
      OriginalAmount: formik.values.AmountLocalCurrency,
    }
    // const newValue = body.AmountLocalCurrency
    // const newValueInt = newValue.replace(',', '')

    if (
      EligibilityForm.IdCurrencyUser === 3 ||
      editFormElegibility.IdCurrencyUser === 3
    ) {
      formik.setFieldValue('AmountDollars', formik.values.AmountLocalCurrency)
    } else {
      try {
        // setLoadingExchange(true)
        const response = await getCurrency(dataCurrency)

        formik.setFieldValue(
          'AmountDollars',
          response.result
            .retrieveGlobalStandardSpecificationCurrencyExchangeResponse
            .currencyExchange.resultingAmount,
        )
      } catch (error) {
        console.log(error)
      }
    }
  }

  const handleGuardar = async (values) => {
    setLoading(true)
    const response = await insertAsset(values)
    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getDataTable()
      handleClose()
      setLoading(false)
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">
              Pérdida de activos físico debido a eventos relacionados con el
              clima
            </h1>
          </div>
          <form id="transfers-form" onSubmit={formik.handleSubmit}>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Activo físico</label>
                <a
                  data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Activo fisico"
                    customInput={TextField}
                    value={formik.values.PhysicalAsset}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setErrorActivo(false)

                        formik.setFieldValue('PhysicalAsset', e.target.value)
                      } else {
                        setErrorActivo(true)
                      }
                    }}
                    maxLength={50}
                  ></textarea>
                  {errorActivo ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.PhysicalAsset ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.PhysicalAsset}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Daño del activo</label>
                <a
                  data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Daño del activo"
                    customInput={TextField}
                    value={formik.values.AssetDamage}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setErrorDanio(false)

                        formik.setFieldValue('AssetDamage', e.target.value)
                      } else {
                        setErrorDanio(true)
                      }
                    }}
                    maxLength={40}
                  ></textarea>
                  {errorDanio ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.AssetDamage ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.AssetDamage}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid
                container
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'stretch',
                }}
              >
                <Grid item xs={12} sm={4} md={4}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        Cantidad de activos
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="AssetsNumber"
                          name="AssetsNumber"
                          allowLeadingZeros={false}
                          customInput={TextField}
                          thousandSeparator={true}
                          value={formik.values.AssetsNumber}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'AssetsNumber',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          decimalScale={0}
                          isNumericString={true}
                          inputProps={{ maxLength: 10 }}
                          error={formik.errors.AssetsNumber}
                        />
                        {formik.errors.AssetsNumber ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.AssetsNumber}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Monto del daño</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <NumberFormat
                          id="TotalSubProjectBudgetDollar"
                          name="TotalSubProjectBudgetDollar"
                          customInput={TextField}
                          allowLeadingZeros={false}
                          thousandSeparator={true}
                          value={formik.values.AmountLocalCurrency}
                          autoComplete="off"
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'AmountLocalCurrency',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          isNumericString={true}
                          inputProps={{ maxLength: 14 }}
                          decimalScale={2}
                          fixedDecimalScale
                          error={formik.errors.AmountLocalCurrency}
                          onBlur={handleCurrency}
                        />
                        {formik.errors.AmountLocalCurrency ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.AmountLocalCurrency}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={4} md={4}>
                  <Grid container spacing={1} className="input__container">
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">Moneda</label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl fullWidth>
                        <Select
                          id="IdProject"
                          name="IdProject"
                          variant="outlined"
                          value={formik.values.IdCurrencySelected}
                          // displayEmpty={true}
                          // renderValue={
                          //   IdCurrencySelected !== ''
                          //     ? undefined
                          //     : () => 'Seleccione una opción'
                          // }
                          // onBlur={handleCurrency}
                          disabled
                        >
                          <MenuItem disabled value="">
                            Seleccione una opción
                          </MenuItem>
                          {currencyType &&
                            currencyType.map((item, key) => (
                              <MenuItem key={key} value={item.IdCurrency}>
                                {item.Description}
                              </MenuItem>
                            ))}
                        </Select>
                        {formik.values.AmountDollars !== '' ? (
                          <div
                            style={{
                              color: 'gray',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {/* ${formik.values.AmountDollars} */}
                            <NumberFormat
                              value={formik.values.AmountDollars}
                              thousandSeparator={true}
                              decimalScale={2}
                              displayType={'text'}
                              isNumericString={true}
                              fixedDecimalScale
                              prefix="$"
                            />
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Evento climático</label>
                <a
                  data-tip="Los caracteres especiales permitidos son: ñ, tildes, guiones, paréntesis, diéresis, coma y punto."
                  data-for="infoCurrencyPop"
                  style={{ cursor: 'pointer' }}
                >
                  <ErrorOutlineIcon fontSize="small" />
                  <ReactTooltip
                    id="infoCurrencyPop"
                    effect="solid"
                    multiline={true}
                    type="dark"
                  />
                </a>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Evento climático"
                    customInput={TextField}
                    value={formik.values.ClimaticEvent}
                    onChange={(e) => {
                      if (
                        e.target.value.match(
                          /[-(),.\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                        ) ||
                        e.target.value === ''
                      ) {
                        setErrorEvento(false)

                        formik.setFieldValue('ClimaticEvent', e.target.value)
                      } else {
                        setErrorEvento(true)
                      }
                    }}
                    maxLength={100}
                  ></textarea>
                  {errorEvento ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.ClimaticEvent ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.ClimaticEvent}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid className="buttonsPYME">
                <Button className="cancelButton" onClick={() => handleClose()}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={validateFormStatus}
                  disabled={loading}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  )
}
